import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleMinus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCircleMinus"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM7.75735 11.5C7.48121 11.5 7.25735 11.7239 7.25735 12C7.25735 12.2761 7.48121 12.5 7.75735 12.5H16.2426C16.5188 12.5 16.7426 12.2761 16.7426 12C16.7426 11.7239 16.5188 11.5 16.2426 11.5H7.75735Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleMinus;
